import { gql } from '@apollo/client'

export const RANKINGS = gql`
  query GetRankings($input: getRankInput!) {
    getRankings(input: $input) {
      aResults {
        nPoints
        _id
        nRank
        nRating
        sName
        sTeam
        oPlayer {
          eTagStatus
          oSeo {
            sSlug
            eStatus
          }
          sCountry
          sCountryFull
          oImg {
            sUrl
            sText
            sCaption
            sAttribute
          }
          sFullName
          sLastName
          sFirstName
        }
        dUpdated
        oTeams {
          oImg {
            sCaption
            sText
            sUrl
            sAttribute
          }
          oSeo {
          sSlug
        }
        }
      }
    }
  }
`
export const TOP_TEAMS = gql`
  query GetRankings($input: getRankInput!) {
    getRankings(input: $input) {
      aResults {
        _id
        sName
        oTeams {
          eTagStatus
          oSeo {
            sSlug
          }
        }
      }
    }
  }
`
export const UPCOMING_MATCHES = gql`
query ListUpcomingMatches($input: listUpcomingMatchesInput) {
  listUpcomingMatches(input: $input) {
    _id
    oTeamA {
      sAbbr
      _id
      oImg {
        sUrl
        sText
        sAttribute
        sCaption
      }
    }
    oSeo {
      sSlug
    }
    oTeamB {
      sAbbr
      _id
      oImg {
        sUrl
        sText
        sCaption
        sAttribute
      }
    }
    dStartDate
  }
  }
`

export const CURRENT_SERIES_LIST = gql`
  query GetCurrentPopularSeries {
    getCurrentPopularSeries {
      aResults {
        _id
        oSeries {
          oCategory {
            oSeo {
              sSlug
            }
            oImg {
            sAttribute
            sText
            sCaption
            sUrl
          }
          }
          oSeo {
            sSlug
          }
          sTitle
        }
      }
    }
  }
`
export const POPULAR_PLAYERS = gql`
query OPlayer {
  getTrendingPlayers {
    oPlayer {
      oImg {
        sUrl
      }
      sFullName
      sFullName
      oSeo {
        sSlug
      }
    }
    sTeam
    eRankType
  }
}
`
export const POPULAR_TEAMS = gql`
query ListPopularTeams {
  listPopularTeams {
    _id
    sTitle
    sAbbr
    sCountryFull
    eTagStatus
    oSeo {
      sSlug
    }
    oImg {
      sUrl
      sText
      sCaption
      sAttribute
    }
  }
}
`
export const DID_YOU_KNOW = gql`
query OData {
  getRandomDidYouKnowData {
    oData {
      dCreated
      dUpdated
      factStr
    }
  }
}
`
